export const rules = {
    input: {
        fieldIsRequired: '* Das Feld ist obligatorisch',
        validPhoneNumber: '* indtast gyldigt telefonnummer i format +45xxxxxxxx',
        validPhoneNumberOrEmail: 'Indtastede tekst skal være en e-mail eller et telefonnummer med format +45xxxxxxxx',
        email: 'Die E-Mail muss gültig sein',
        min4Char: '* Ihr Passwort muss mindestens 4 Zeichen enthalten',
    }
};
